import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { ClipboardList, Menu, X, ShieldCheck, UserCircle2 } from "lucide-react";
import { useQuote } from "@/context/QuoteContext";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/catalog", label: "Catalog", id: "nav-link-catalog" },
  { to: "/brands", label: "Brands", id: "nav-link-brands" },
  { to: "/how-to-order", label: "How to Order", id: "nav-link-how-to-order" },
  { to: "/contact", label: "Contact", id: "nav-link-contact" },
];

export const Header = () => {
  const { count, setOpen } = useQuote();
  const { user } = useAuth();
  const [mobile, setMobile] = useState(false);
  const cls = ({ isActive }) =>
    `text-sm font-semibold transition-colors ${isActive ? "text-[#1E7CF2]" : "text-[#0B1F4B] hover:text-[#1E7CF2]"}`;

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 h-[76px] md:h-[92px] flex items-center justify-between gap-6">
        <Link to="/" data-testid="header-logo" className="flex items-center shrink-0">
          <img src="/logo-nav.png" alt="ShelfReady AI" className="h-[56px] sm:h-[64px] md:h-[76px] w-auto max-w-none object-contain" />
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => <NavLink key={l.to} to={l.to} data-testid={l.id} className={cls}>{l.label}</NavLink>)}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/account" data-testid="nav-link-account" className="hidden md:inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500 hover:text-[#0B1F4B] px-3 py-2">
            <UserCircle2 size={15} /> {user ? (user.name?.split(" ")[0] || "Account") : "Buyer sign in"}
          </Link>
          {(!user || user.role === "admin") && <Link to="/admin" data-testid="nav-link-admin" className="hidden md:inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500 hover:text-[#0B1F4B] px-3 py-2">
            <ShieldCheck size={15} /> Admin
          </Link>}
          <button data-testid="quote-drawer-toggle" onClick={() => setOpen(true)}
            className="relative inline-flex items-center gap-2 rounded-full bg-[#0B1F4B] text-white px-4 py-2 text-sm font-semibold hover:bg-[#1E7CF2] transition-colors">
            <ClipboardList size={16} /> <span className="hidden sm:inline">Quote List</span>
            {count > 0 && <span data-testid="quote-count-badge" className="ml-1 rounded-full bg-[#E63946] text-white text-[11px] font-bold px-2 py-0.5">{count}</span>}
          </button>
          <button className="md:hidden p-2 text-[#0B1F4B]" data-testid="mobile-menu-toggle" onClick={() => setMobile(!mobile)}>
            {mobile ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {mobile && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          {links.map((l) => <NavLink key={l.to} to={l.to} onClick={() => setMobile(false)} className={cls}>{l.label}</NavLink>)}
          <Link to="/account" onClick={() => setMobile(false)} className="text-sm font-semibold text-slate-500">{user ? "My account" : "Buyer sign in"}</Link>
          <Link to="/admin" onClick={() => setMobile(false)} className="text-sm font-semibold text-slate-500">Admin</Link>
        </div>
      )}
    </header>
  );
};
